const SubmitSuccessScreen = ({ setScreen,   employee, }) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow text-center max-w-md mx-auto">
      {/* Checkmark icon using inline SVG */}
      <div className="flex justify-center mb-4 mt-3">
       <svg xmlns="http://www.w3.org/2000/svg" width="58" height="42" viewBox="0 0 58 42" fill="none">
  <path d="M20.016 32.7988L51.091 2.07688C51.8244 1.35188 52.6799 0.98938 53.6577 0.98938C54.6355 0.98938 55.491 1.35188 56.2244 2.07688C56.9577 2.80188 57.3244 3.66342 57.3244 4.66151C57.3244 5.65959 56.9577 6.51992 56.2244 7.24251L22.5827 40.5925C21.8494 41.3175 20.9938 41.68 20.016 41.68C19.0382 41.68 18.1827 41.3175 17.4494 40.5925L1.68269 25.005C0.949359 24.28 0.597359 23.4197 0.626692 22.424C0.656026 21.4283 1.03858 20.5668 1.77436 19.8394C2.51014 19.112 3.38158 18.7495 4.38869 18.7519C5.3958 18.7543 6.26603 19.1168 6.99936 19.8394L20.016 32.7988Z" fill="black"/>
</svg>
      </div>

      <h2 className="text-xl font-semibold text-[#0A0A0A] mb-2">You're done!</h2>
      <p className="text-gray-600 mb-4">Thank you, {employee ? `${employee.firstname} ${employee.lastname}` : ""}!</p>

      <p className="text-sm text-gray-500 mb-6">
        Your face recognition setup is complete. You can now use facial recognition
        to access secure areas and systems.
      </p>

      <button
        className="bg-[#0A0A0A] text-white px-6 py-2 rounded hover:bg-gray-800"
        onClick={() => setScreen(0)}
      >
        Setup Another Employee
      </button>
    </div>
  );
};

export default SubmitSuccessScreen;
